import { createSlice } from '@reduxjs/toolkit';

import type { PayloadAction } from '@reduxjs/toolkit';

export interface MfeAuthState {
	accessToken: string | null;
	refreshToken: string | null;
	userInfo: {
		email: string | null;
		name: string | null;
		picture: string | null;
	} | null;
	isAuthenticated: boolean;
	isLoading: boolean;
	error: string | null;
}

const initialState: MfeAuthState = {
	accessToken: null,
	refreshToken: null,
	userInfo: null,
	isAuthenticated: false,
	isLoading: false,
	error: null,
};

const authSlice = createSlice({
	name: 'mfeAuth',
	initialState,
	reducers: {
		setLoading: (state, action: PayloadAction<boolean>) => {
			state.isLoading = action.payload;
		},
		setAccessToken: (state, action: PayloadAction<string | null>) => {
			state.accessToken = action.payload;
			state.isAuthenticated = !!action.payload;
		},
		setRefreshToken: (state, action: PayloadAction<string | null>) => {
			state.refreshToken = action.payload;
		},
		setUserInfo: (state, action: PayloadAction<MfeAuthState['userInfo']>) => {
			state.userInfo = action.payload;
		},
		setError: (state, action: PayloadAction<string | null>) => {
			state.error = action.payload;
		},
		loginSuccess: (
			state,
			action: PayloadAction<{
				accessToken: string;
				refreshToken?: string;
				userInfo: MfeAuthState['userInfo'];
			}>,
		) => {
			state.accessToken = action.payload.accessToken;
			state.refreshToken = action.payload.refreshToken || null;
			state.userInfo = action.payload.userInfo;
			state.isAuthenticated = true;
			state.isLoading = false;
			state.error = null;
		},
		logout: (state) => {
			state.accessToken = null;
			state.refreshToken = null;
			state.userInfo = null;
			state.isAuthenticated = false;
			state.isLoading = false;
			state.error = null;
		},
		clearError: (state) => {
			state.error = null;
		},
	},
});

export const {
	setLoading,
	setAccessToken,
	setRefreshToken,
	setUserInfo,
	setError,
	loginSuccess,
	logout,
	clearError,
} = authSlice.actions;

export default authSlice.reducer;
